import { useMemo } from "react";
import { useTenant } from "hooks/settings";
import {
  useListUploadedFilesQuery,
  UploadedFileMeta,
} from "src/store/api/generatedApi";

interface InventoryReportFileStatus {
  file: UploadedFileMeta | null;
  isPresent: boolean;
  isProcessed: boolean;
}

interface RecentInventoryReportFileResult {
  fileStatus: InventoryReportFileStatus;
  isLoading: boolean;
  refetch: () => void;
}

export const useRecentInventoryReportFile = (
  since: string
): RecentInventoryReportFileResult => {
  const tenant = useTenant();

  const {
    data: inventoryReportFiles = [],
    isLoading,
    refetch,
  } = useListUploadedFilesQuery({
    tenantName: tenant,
    types: ["inventory_report"],
    deleted: false,
    since,
    limit: 1,
    order: "desc",
  });

  const fileStatus: InventoryReportFileStatus = useMemo(() => {
    const file = inventoryReportFiles[0] ?? null;
    return {
      file,
      isPresent: file !== null,
      isProcessed: file?.state === "parsed",
    };
  }, [inventoryReportFiles]);

  return {
    fileStatus,
    isLoading,
    refetch: () => {
      void refetch();
    },
  };
};
